import { WebcastEntry } from "@kaltura/mediaspace-shared-types";

export enum NotificationType {
    single = "single",
    many = "many",
    gap = "gap",
}

export type JoinNextSessionNotification = {
    type: NotificationType.single;
    session: WebcastEntry;
    timeTillStart: number;
    onWatch: (session: WebcastEntry, notificationId: string) => void;
    onStay: (notificationId: string) => void;
    analyticsEntryId?: string;
};

export type GapNotification = {
    type: NotificationType.gap;
    gapInMinutes: number;
    session: WebcastEntry;
    onGoToSession: (session: WebcastEntry, notificationId: string) => void;
    onBrowseSession: (notificationId: string) => void;
    analyticsEntryId?: string;
};

export type MultipleSessionNotification = {
    type: NotificationType.many;
    upcomingSessions: WebcastEntry[];
    onBrowseSessions: (notificationId: string) => void;
    analyticsEntryId?: string;
};

export type Notification = JoinNextSessionNotification | GapNotification | MultipleSessionNotification;
